import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteeTableRecords from '../../_partials/GuaranteesTableRecords';

const AwaitingApprovalGuarantees = ({ TabsRaw }: any) => (
  <GuaranteeTableRecords
    TabsRaw={TabsRaw}
    defaultUrl={AdminRouteName.awaitingApprovalGuaranteesRoute}
    tabStatus="AWAITING_APPROVAL"
    toggleStorageId="awaiting-approval-guarantees-table-col"
    hasNameAndImage
    permissionName="can-view-awaiting-approval-guarantees"
  />
);
export default AwaitingApprovalGuarantees;
